import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import RegistroAnalisisCausal from "./components/RegistroAnalisisCausal";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import DesviacionService from "../../services/DesviacionService";
import { IDesviacion } from "../../entities/IDesviacion";
import Loading from "../../cross/Loading";
import AgregarDesviacion from "./AgregarDesviacion";
import DesviacionRegistrarCierre from "./components/DesviacionRegistrarCierre";
import { EnumEstadoDesviacion } from "../../entities/helper/EnumEstadoDesviacion";
import AccionesAsignadas from "./components/AccionesAsignadas";
import { ETipoCausa } from "../../enums/E_TipoCausa";
import { E_EstadoFormPerfilamiento } from "../../enums/E_EstadoFormulario";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import { API_AUDITORIA, API_AUDITORIA_GET_AUDITORIA, ROW_COUNT_MAX } from "../../helpers/variableHelper";
import { ICausaBasica } from "../../entities/ICausaBasica";
import { ICausaInmediata } from "../../entities/ICausaInmediata";
import { ICausaSistema } from "../../entities/ICausaSistema";
import { E_EstadoCausa } from "../../enums/E_EstadoCausa";
import { ETipoDesviacion } from "../../enums/E_TipoDesviacion";
import IAuditoria from "../../entities/IAuditoria";
import { getAPI } from "../../helpers/httpHelper";

type Causa = ICausaBasica | ICausaInmediata | ICausaSistema | null;
type Dev = IDesviacion | null | undefined;
interface IStepsDesviacionProps {
  loading?: boolean;
  is_test?: boolean;
  desv?: IDesviacion;
  tp?: string;
  ca?: Causa;
}

export default function StepsDesviacion({ is_test, ca, loading, desv, tp }: IStepsDesviacionProps) {
  const Test = (is_test?: boolean) => {
    return is_test ? "1" : "0";
  };
  let search = new URLSearchParams(window.location.search);
  const idDesviacion = parseInt(search.get("id") || Test(is_test));
  const idCausa = parseInt(search.get("idCausa") || Test(is_test));
  const selectedTipoCausa: ETipoCausa = parseInt(search.get("tp") || (is_test ? tp ?? "1" : "0"));
  const [token, setToken] = useState("");
  const [isLoading, setIsloading] = useState(true);
  const [selectedDesviacion, setSelectedDesviacion] = useState<Dev>(null);
  const [estadoForm, setEstadoForm] = useState<E_EstadoFormPerfilamiento>(E_EstadoFormPerfilamiento.Lectura);
  const [estadoFormAccionesAsignadas, setEstadoFormAccionesAsignadas] = useState<E_EstadoFormPerfilamiento>(E_EstadoFormPerfilamiento.Lectura);
  const [slctCausa, setSelectedCausa] = useState<Causa>(null);
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [selectedAudit, setSelectedAudit] = useState<IAuditoria | null>(null);
  console.log(slctCausa);

  usePromiseEffect(async () => {
    // NO SONAR Dejamos justificado que estas validaciones corresponden a validacion de propiedades en la carga del formulario
    let token = await cognitoUserToken();
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    let resultDesviacion: IDesviacion | null | undefined = null;
    setToken(token);
    let slcCausa: ICausaBasica | ICausaInmediata | ICausaSistema | null = null;
    if (idDesviacion) {
      resultDesviacion = is_test ? desv : await DesviacionService.getDesvicacionByID(token, idDesviacion);
      if (resultDesviacion && resultDesviacion.ID_AUDITORIA) {
        let resultGetAudit: IAuditoria = (
          await getAPI(`${API_AUDITORIA}${API_AUDITORIA_GET_AUDITORIA}`, { Authorization: `Bearer ${token}` }, { ID: resultDesviacion.ID_AUDITORIA })
        ).result;

        setSelectedAudit(resultGetAudit);
      }
      setSelectedDesviacion(resultDesviacion);
      if (
        resultDesviacion?.ID_ESTADO === EnumEstadoDesviacion.AccionesEjecucion ||
        resultDesviacion?.ID_ESTADO === EnumEstadoDesviacion.AccionesCausasRechazadas ||
        (resultDesviacion?.ID_ESTADO === EnumEstadoDesviacion.VerificacionCierreAcciones && idCausa) ||
        (resultDesviacion?.ID_ESTADO === EnumEstadoDesviacion.VerificacionCausasRechazadas && idCausa)
      ) {
        let paramActive = {
          ORDENADOPOR: "ID",
          ORIENTACION: "DESC",
          PAGINA: 1,
          PAGINADO: ROW_COUNT_MAX,
        };
        if (selectedTipoCausa === ETipoCausa.Inmediata) {
          let listI = is_test
            ? { data: [ca] }
            : await DesviacionService.getListadoCausaInmediata(token, {
                ID: idDesviacion,
                ...paramActive,
              });
          setSelectedCausa(listI?.data.filter((i) => i?.ID === idCausa).shift() || null);
          slcCausa = listI?.data.filter((i) => i?.ID === idCausa).shift() || null;
        } else if (selectedTipoCausa === ETipoCausa.Basica) {
          let listB = is_test
            ? { data: [ca] }
            : await DesviacionService.getListadoCausaBasica(token, {
                ID: idDesviacion,
                ...paramActive,
              });
          setSelectedCausa(listB.data.filter((b) => b?.ID === idCausa).shift() || null);
          slcCausa = listB.data.filter((b) => b?.ID === idCausa).shift() || null;
        } else {
          let listS = is_test
            ? { data: [ca] }
            : await DesviacionService.getListadoCausaSistema(token, {
                ID: idDesviacion,
                ...paramActive,
              });
          setSelectedCausa(listS?.data.filter((s) => s?.ID === idCausa).shift() || null);
          slcCausa = listS?.data.filter((s) => s?.ID === idCausa).shift() || null;
        }
      }
    }

    perfilamiento(currUser, resultDesviacion, slcCausa);
    setIsloading(false);
  }, []);

  const tabActiveKey = () => {
    if (selectedTipoCausa && idCausa) {
      return "accionesasignadas";
    } else if (
      (selectedDesviacion && selectedDesviacion?.ID_ESTADO === EnumEstadoDesviacion.RegistroAnalisisCausal) ||
      selectedDesviacion?.ID_ESTADO === EnumEstadoDesviacion.RegistroCausasInmediatas ||
      selectedDesviacion?.ID_ESTADO === EnumEstadoDesviacion.RegistroAmbitosGestion
    ) {
      return "registrocausas";
    } else if (
      selectedDesviacion &&
      selectedDesviacion?.ID_ESTADO >= EnumEstadoDesviacion.VerificacionCierreAcciones &&
      ((selectedDesviacion.RESPONSABLE_INVESTIGACION === currentUser?.email && selectedDesviacion?.ID_AUDITORIA === null) ||
        ((selectedDesviacion.RESPONSABLE_CIERRE === currentUser?.email ||
          isParticipatingAudit(selectedAudit?.AUDITORES_ACOMPANANTES, currentUser?.email)) &&
          selectedDesviacion?.ID_AUDITORIA !== null))
    ) {
      return "registrocierre";
    } else {
      return "ingreso";
    }
  };
  const perfilamiento = (currUser: ICurrentUser, desviacion: Dev, selectedCausa?: Causa) => {
    // NOSONAR Dejamos justificado que estas validaciones corresponden a validaciones propias del perfilamiento de las etapas de una desviación
    if (desviacion != null && idDesviacion != null) {
      if (desviacion.ID_ESTADO === EnumEstadoDesviacion.EnConstruccion && desviacion.AUTOR === currUser.email) {
        setEstadoForm(E_EstadoFormPerfilamiento.Ingresar);
      } else if (
        (desviacion.ID_ESTADO === EnumEstadoDesviacion.RegistroAnalisisCausal ||
          desviacion.ID_ESTADO === EnumEstadoDesviacion.RegistroCausasInmediatas ||
          desviacion.ID_ESTADO === EnumEstadoDesviacion.RegistroAmbitosGestion) &&
        desviacion.RESPONSABLE_INVESTIGACION === currUser.email
      ) {
        setEstadoForm(E_EstadoFormPerfilamiento.Ingresar);
      } else if (
        (desviacion.ID_ESTADO === EnumEstadoDesviacion.AccionesEjecucion ||
          desviacion.ID_ESTADO === EnumEstadoDesviacion.VerificacionCierreAcciones ||
          desviacion.ID_ESTADO === EnumEstadoDesviacion.AccionesCausasRechazadas ||
          desviacion.ID_ESTADO === EnumEstadoDesviacion.VerificacionCausasRechazadas) &&
        (selectedCausa?.RESPONSABLE === currUser.email ||
          desviacion.RESPONSABLE_INVESTIGACION === currUser.email ||
          desviacion.RESPONSABLE_CIERRE === currUser.email) &&
        (selectedCausa?.ID_ESTADO === E_EstadoCausa.Asignada || selectedCausa?.ID_ESTADO === E_EstadoCausa.Rechazada)
      ) {
        setEstadoFormAccionesAsignadas(E_EstadoFormPerfilamiento.Ingresar);
      }
    } else {
      setEstadoForm(E_EstadoFormPerfilamiento.Ingresar);
    }
  };
  const isParticipatingAudit = (users: string | undefined, emailUser: string | undefined) => {
    if (users !== undefined && users !== null) {
      let arrayUsers = users.split("; ");
      const result = arrayUsers.some((user) => user.trim() === emailUser);
      return result;
    }
    return false;
  };
  const canShowRegistrarCierre = (): boolean => {
    if (!selectedDesviacion) return false;

    const estado = selectedDesviacion.ID_ESTADO;

    const estaEnEtapaCierre =
      estado >= EnumEstadoDesviacion.AccionesEjecucion &&
      estado !== EnumEstadoDesviacion.RegistroCausasInmediatas &&
      estado !== EnumEstadoDesviacion.RegistroAmbitosGestion;

    return estaEnEtapaCierre;
  };
  return (
    <div className="col-12" title="-">
      <div className="rounded bg-white p-2 shadow">
        {isLoading ? (
          <Loading />
        ) : (
          <Tabs defaultActiveKey={tabActiveKey()} id="uncontrolled-tab-example" className="mb-3">
            <Tab
              eventKey="ingreso"
              title={
                <span>
                  Ingreso - Validación <i className="bi bi-eye" />{" "}
                </span>
              }>
              <AgregarDesviacion readonly={estadoForm === E_EstadoFormPerfilamiento.Lectura} selectedAudit={selectedAudit} />
            </Tab>
            {selectedDesviacion && selectedDesviacion?.ID_ESTADO >= EnumEstadoDesviacion.RegistroAnalisisCausal ? (
              <Tab
                eventKey="registrocausas"
                title={
                  <span>
                    {selectedDesviacion.ID_TIPO_DESVIACION === ETipoDesviacion.OportunidadMejora
                      ? "Registro Oportunidad"
                      : "Registrar Análisis Causal"}{" "}
                    <i className="bi bi-eye" />
                  </span>
                }>
                <RegistroAnalisisCausal token={token} readonly={estadoForm === E_EstadoFormPerfilamiento.Lectura} selectedAudit={selectedAudit} />
              </Tab>
            ) : null}
            {selectedTipoCausa && idCausa ? (
              <Tab
                eventKey="accionesasignadas"
                title={
                  <span>
                    Acciones Asignadas <i className="bi bi-eye" />
                  </span>
                }>
                <AccionesAsignadas token={token} readonly={estadoFormAccionesAsignadas === E_EstadoFormPerfilamiento.Lectura} />
              </Tab>
            ) : null}
            {canShowRegistrarCierre() ? (
              <Tab
                eventKey="registrocierre"
                title={
                  <span>
                    Registrar Cierre <i className="bi bi-eye" />
                  </span>
                }>
                <DesviacionRegistrarCierre token={token} readonly={estadoForm === E_EstadoFormPerfilamiento.Lectura} selectedAudit={selectedAudit} />
              </Tab>
            ) : null}
          </Tabs>
        )}
      </div>
    </div>
  );
}
